import React, { useEffect, useState } from 'react';
import { BeforeAfterSlider } from '../components/BeforeAfterSlider';
import { CTABanner } from '../components/CTABanner';
type Category = 'All' | 'Roofs' | 'Siding' | 'Driveways' | 'Decks' | 'Fences' | 'Commercial';
export function Gallery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activeTab, setActiveTab] = useState<Category>('All');
  const categories: Category[] = ['All', 'Roofs', 'Siding', 'Driveways', 'Decks', 'Fences', 'Commercial'];
  const galleryItems = [{
    category: 'Roofs',
    label: 'Roof Cleaning',
    before: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1558611848-73f7eb4001a1?w=800&q=80'
  }, {
    category: 'Siding',
    label: 'Vinyl Siding',
    before: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80'
  }, {
    category: 'Driveways',
    label: 'Concrete Driveway',
    before: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
  }, {
    category: 'Decks',
    label: 'Wood Deck Restoration',
    before: 'https://images.unsplash.com/photo-1591825729269-caeb344f6df2?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=800&q=80'
  }, {
    category: 'Fences',
    label: 'Wood Fence',
    before: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
  }, {
    category: 'Commercial',
    label: 'Storefront Cleaning',
    before: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80'
  }, {
    category: 'Siding',
    label: 'Stucco Cleaning',
    before: 'https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80'
  }, {
    category: 'Driveways',
    label: 'Paver Patio',
    before: 'https://images.unsplash.com/photo-1584622781564-1d987f7333c1?w=800&q=60',
    after: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
  }];
  const filteredItems = activeTab === 'All' ? galleryItems : galleryItems.filter(item => item.category === activeTab);
  return <div className="w-full" data-id="element-374">
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-navy" data-id="element-375">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1558611848-73f7eb4001a1?w=1200')] bg-cover bg-center opacity-20" data-id="element-376"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-377">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-black text-white mb-6" data-id="element-378">
            Before & After Gallery
          </h1>
          <p className="text-xl text-cream max-w-3xl mx-auto" data-id="element-379">
            See the dramatic difference professional soft washing makes on
            various exterior surfaces.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 md:py-24 bg-gray-50 min-h-[600px]" data-id="element-380">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-381">
          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-382">
            {categories.map(category => <button key={category} onClick={() => setActiveTab(category)} className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${activeTab === category ? 'bg-navy text-white shadow-md' : 'bg-white text-gray-600 hover:bg-cream hover:text-navy border border-gray-200'}`} data-id="element-383">
                {category}
              </button>)}
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-384">
            {filteredItems.map((item, index) => <div key={`${item.category}-${index}`} className="animate-fade-in" data-id="element-385">
                <BeforeAfterSlider beforeImage={item.before} afterImage={item.after} label={item.label} data-id="element-386" />
              </div>)}
          </div>

          {filteredItems.length === 0 && <div className="text-center py-20 text-gray-500" data-id="element-387">
              <p className="text-xl" data-id="element-388">
                More photos coming soon to this category!
              </p>
            </div>}
        </div>
      </section>

      <CTABanner data-id="element-389" />
    </div>;
}